// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FMGn3","header":"styles_header__JyccE","title":"styles_title__Bc675"};